import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck } from 'lucide-react';
import { PRIVACY_CONTACT } from '../utils/dpdp';

// DPDP Act 2023 consent notice + mandatory checkbox shown before submitting any form that collects personal data.
export const ConsentNotice = ({ purpose, checked, onChange, assisted = false, items }) => {
  const defaultItems = [
    'Identity & contact details (name, email, phone)',
    'KYC / financial information you provide in this form',
    'Any documents you upload',
  ];
  const list = items || defaultItems;

  return (
    <div className="bg-slate-50 border-2 border-slate-200 rounded-xl p-5" data-testid="consent-notice">
      <div className="flex items-center gap-2 mb-3">
        <ShieldCheck className="text-green-600" size={20} />
        <h4 className="font-bold text-slate-900">Data Protection Notice (DPDP Act, 2023)</h4>
      </div>
      <p className="text-sm text-slate-600 mb-2">
        {PRIVACY_CONTACT.company} will collect and process the following personal data for the purpose of <strong>{purpose}</strong>:
      </p>
      <ul className="list-disc pl-5 text-sm text-slate-600 space-y-1 mb-3">
        {list.map((it, i) => <li key={i}>{it}</li>)}
      </ul>
      <p className="text-xs text-slate-500 mb-4">
        Your data is stored securely and used only for the stated purpose. You may withdraw consent or request access,
        correction or erasure of your data at any time via our{' '}
        <Link to="/data-request" target="_blank" className="text-blue-600 underline">Data Rights request form</Link>. For details, read our{' '}
        <Link to="/privacy" target="_blank" className="text-blue-600 underline">Privacy Policy</Link>. Grievances:{' '}
        <a href={`mailto:${PRIVACY_CONTACT.grievanceEmail}`} className="text-blue-600 underline">{PRIVACY_CONTACT.grievanceEmail}</a>.
      </p>
      <label className="flex items-start gap-3 cursor-pointer">
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          className="mt-1 w-4 h-4 text-green-600 flex-shrink-0"
          data-testid="consent-checkbox"
        />
        <span className="text-sm text-slate-700">
          {assisted
            ? 'I confirm that the investor has read the above notice and the Privacy Policy, and has given free, informed consent to the collection and processing of their personal data for the stated purpose.'
            : 'I have read the above notice and the Privacy Policy, and I give my free, informed consent to the collection and processing of my personal data for the stated purpose.'}
          <span className="text-red-500"> *</span>
        </span>
      </label>
    </div>
  );
};

export default ConsentNotice;
